/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateInvoiceSchema
 */
export interface CreateInvoiceSchema {
    /**
     * 
     * @type {string}
     * @memberof CreateInvoiceSchema
     */
    organizationName: string;
    /**
     * 
     * @type {Date}
     * @memberof CreateInvoiceSchema
     */
    periodStart: Date;
    /**
     * 
     * @type {Date}
     * @memberof CreateInvoiceSchema
     */
    periodEnd: Date;
    /**
     * 
     * @type {number}
     * @memberof CreateInvoiceSchema
     */
    totalUsd: number;
}

/**
 * Check if a given object implements the CreateInvoiceSchema interface.
 */
export function instanceOfCreateInvoiceSchema(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "organizationName" in value;
    isInstance = isInstance && "periodStart" in value;
    isInstance = isInstance && "periodEnd" in value;
    isInstance = isInstance && "totalUsd" in value;

    return isInstance;
}

export function CreateInvoiceSchemaFromJSON(json: any): CreateInvoiceSchema {
    return CreateInvoiceSchemaFromJSONTyped(json, false);
}

export function CreateInvoiceSchemaFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateInvoiceSchema {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'organizationName': json['organization_name'],
        'periodStart': (new Date(json['period_start'])),
        'periodEnd': (new Date(json['period_end'])),
        'totalUsd': json['total_usd'],
    };
}

export function CreateInvoiceSchemaToJSON(value?: CreateInvoiceSchema | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'organization_name': value.organizationName,
        'period_start': (value.periodStart.toISOString()),
        'period_end': (value.periodEnd.toISOString()),
        'total_usd': value.totalUsd,
    };
}

